import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ErrorToast } from '../../components';
import { getUserFromLS, setUserToLS } from '../../helpers/localstorage-helper';
import { ENTRY_PACKAGE } from '../../routes/routes';

export const setMavieMigrationModalChecked = createAsyncThunk(
  'auth/setMavieMigrationModalChecked',
  async (
    {
      setTermsConditionsModal,
      history
    }: { setTermsConditionsModal: (modal: boolean) => void; history: any },
    { rejectWithValue }
  ) => {
    try {
      await axios.put(`/user/set-mavie-migration-modal-checked`);

      setTermsConditionsModal(false);

      const user = getUserFromLS();

      const userForLs = {
        ...user,
        isMavieMigrationModalChecked: true
      };

      setUserToLS(userForLs);
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      return rejectWithValue(error.response.data.error);
    }
  }
);
